<template>
  <div class="bg-white table-padding rounded shadow relative">
    <div slot="header">
      <div class="">
        <el-form>
          <el-row>
            <el-form-item class="custom-input__static">
              <el-select v-model="engine_id" @change="getStatistical" placeholder="メニューを選んでください" :clearable="true">
                <el-option v-for="fun in listFunction" :key="fun.id" :value="fun.id"
                           :label="fun.name"/>
              </el-select>
              <el-date-picker v-model="start_date" @change="getStatistical" :picker-options="datePickerOptions"
                              type="month" placeholder="pick a month" value-format="yyyy-MM" format="yyyy-MM"
                              v-on="$listeners" :clearable="false">
              </el-date-picker>
              <div class="title-total">処理した枚数の合計</div>
              <el-input :value="totalSheet" class="el-input__total" :clearable="false" disabled/>
              <el-button
                  :disabled="dataListStatistical.length < 1"
                  :loading="loading"
                  @click="downloadCsv"
                  type="text"
                  title="Download xlsx"
                  class="custom-btn-add"
              >
                xlsxファイルに書き出す
              </el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
    </div>
    <el-table :data="dataListStatistical" class="w-full data-user mt-4 height-list mb-14">
      <template v-slot:empty>
        <span>データなし</span>
      </template>
      <el-table-column v-for="(item,key,index) in dataListStatistical[0]" :prop="key"
                       :label="key" :key="index" min-width="200">
      </el-table-column>
    </el-table>
    <el-pagination
        class="text-right mt-4 absolute right-0 bottom-0 w-full bg-white py-4"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="paginate.currentPage"
        :page-sizes="configPaginate.page_sizes"
        :page-size="configPaginate.page_size"
        layout="prev, pager, next, sizes"
        :total="paginate.totalItem"
    >
    </el-pagination>

    <el-dialog title="" :visible.sync="isOpenDeleteModal" width="30%">
      <span>このユーザーを削除しますか。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isOpenDeleteModal = false">いいえ</el-button>
        <el-button type="danger">
          はい、削除する
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import formatDate from "@/plugins/formatDate.js";
import {configPaginate} from "@/config/paginate";
import {ROLE_ADMIN} from "@/constants/organization";
import adminStatisticalAPI from "@/api/admin_statstical.api";
import moment from "moment";

export default {
  filters: {
    formatDate: formatDate
  },

  data: function () {
    return {
      start_date: '',
      totalSheet: 0,
      configPaginate,
      paginate: {
        currentPage: 1,
        totalPage: 1,
        totalItem: 0,
      },
      isOpenDeleteModal: false,
      dataListStatistical: [],
      totalPage: 1,
      engine_id: null,
      org_id: null,
      name_search: null,
      loading: false,
      listFunction: [],
      datePickerOptions: {
        disabledDate(date) {
          return date > moment() || date < moment("2021-01-01")
        }
      }
    };
  },

  computed: {
    ...mapState({
      users: (state) => state.admin_user.users,
      authUser: state => state.auth.authUser
    }),
  },

  methods: {
    ...mapActions("admin_organizations", ["getDetail"]),
    getDateNow() {
      return moment().format('yyyy-MM')
    },
    formatDateHour(date) {
     return  moment(date).format('YYYY-MM-DD H:mm:ss')
    },
    async downloadCsv() {
      this.loading = true
      const from_date = moment(this.start_date).clone().startOf('month').format('DD-MM-YYYY')
      const to_date = moment(this.start_date).clone().endOf('month').format('DD-MM-YYYY')
      const data = {
        org_id: this.org_id,
        from_date: from_date,
        to_date: to_date,
        page_size: this.configPaginate.page_size,
        page: this.paginate.currentPage,
        engine_id: this.engine_id,
        export_type: 1
      }
      await adminStatisticalAPI.downloadCsv(data).then((res) => {
        if (res.success && res.data) {
          const url_bash = process.env.VUE_APP_BACK_END_URL + '/' + res.data
          let a = document.createElement("a");
          a.setAttribute('href', url_bash);
          a.setAttribute('download', '');
          a.setAttribute('target', '_blank');
          a.click();
          setTimeout(() => {
            window.URL.revokeObjectURL(url_bash)
          }, 100)
          a.remove()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    async handleSizeChange(val) {
      this.configPaginate.page_size = val;
      await this.getStatistical();
    },
    async handleCurrentChange(val) {
      this.paginate.currentPage = val;
      await this.getStatistical();
    },
    async getStatistical() {
      const from_date = moment(this.start_date).clone().startOf('month').format('DD-MM-YYYY')
      const to_date = moment(this.start_date).clone().endOf('month').format('DD-MM-YYYY')
      const data = {
        org_id: this.org_id,
        from_date: from_date,
        to_date: to_date,
        page_size: this.configPaginate.page_size,
        page: this.paginate.currentPage,
        engine_id: this.engine_id
      }
      const result = await adminStatisticalAPI.listStatistical(data);
      if (result.success) {
        const rs = result.data;
        this.dataListStatistical = rs.results;
        this.paginate.currentPage = rs.current_page;
        this.configPaginate.page_size = rs.page_size;
        this.paginate.totalPage = rs.num_pages;
        this.paginate.totalItem = rs.count;
        this.totalSheet = rs.total_run ?? 0;
      }
    }
  },

  async created() {
    this.start_date = this.getDateNow()
    if (this.authUser.role === ROLE_ADMIN && this.authUser.is_superuser) {
      if (!this.$route.params.id) {
        return this.$router.push('/404')
      }
      const res = await this.getDetail({id: this.$route.params.id})
      if (!res.success) {
        return this.$router.push('/404')
      }
      this.listFunction = res.data.engine_list
      this.org_id = this.$route.params.id
    } else if (this.authUser.role === ROLE_ADMIN) {
      const res = await this.getDetail({id: this.authUser.org_id})
      this.listFunction = res.data.engine_list
      this.org_id = this.authUser.org_id
    }
    await this.getStatistical()
  },
  beforeMount() {
      this.$router.push({ name: "home" });
  },
};
</script>

<style scoped>
.custom-input__static {
  margin-top: 10px;
}

.custom-input__static > /deep/ .el-form-item__content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.custom-input__static > .el-form-item__content > div {
  margin-right: 10px;
}

.el-input__total {
  width: 200px;
}



.height-list {
  height: calc(100vh - 320px);
  overflow-y: scroll;
}

.height-list::-webkit-scrollbar {
  display: none;
}

.custom-btn-add {
  background: #fdb92c;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #0f172a;
  padding: 5px 16px;
  font-weight: 400;
}

.data-user table th {
  padding: 17px 10px;
  font-weight: 400;
  background: #fdf4e0;
  text-align: left;
  color: black;
}

.data-user table td {
  padding: 10px;
  color: black;
}

@media screen and (max-width: 1366px) {
  .table-padding {
    padding: 1.6rem;
  }
}

@media screen and (max-width: 768px) {
  .custom-input__static > .el-form-item__content > div, button {
    margin-top: 10px;
  }

  .search-user {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}

@media screen and (max-width: 300px) {
}

</style>
